module.exports = __webpack_public_path__ + "fonts/inter-v11-latin-800.0a74b41.woff2";